module.exports = new __parcel__URL__("rain.1e27d28c.mp3").toString();